import { FC } from "react";
import { Redirect } from "react-router";
import { routes } from "../../state/common/constants/routes.constants";

export const RedirectScreen: FC = () => <Redirect to={routes.login.path} />;
